import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/lib/seo/head";
import HowWeMakeMoney from "@/pages/HowWeMakeMoney";

export const Route = createFileRoute("/how-we-make-money")({
  head: () => seoHead("/how-we-make-money"),
  component: HowWeMakeMoney,
});
